import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { makeGetFilteredProjects } from 'selectors/project';

export const useProjects = (filterType = 'ALL') => {
    const selectFilteredProjects = useMemo(() => makeGetFilteredProjects(filterType), [filterType]);
    return useSelector(selectFilteredProjects);
};
